// src/features/presence/session-section.tsx
import { KpiTile } from "@/components/iris";
import { Kicker } from "@/components/iris/kicker";
import { formatCount } from "@/lib/format-count";
import type { Env, PresenceSummary } from "@/lib/types";
import { Clock, Gauge, Hourglass, ListChecks, Timer } from "lucide-react";
import { formatDuration, formatRatioPct } from "./format";

interface SessionSectionProps {
  data: PresenceSummary;
  env: Env;
}

/**
 * IR-1148 §3 — session quality: durations (total/active), engagement ratio,
 * and total session count for the window.
 */
export function SessionSection({ data, env }: SessionSectionProps) {
  const kpiEnv = env === "dev" ? "dev" : "prod";
  return (
    <>
      <Kicker style={{ marginTop: 32, marginBottom: 12 }}>Session Quality</Kicker>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 16 }}>
        <KpiTile
          label="Avg Session"
          value={formatDuration(data.avg_session_duration_sec)}
          icon={Clock}
          tone="cyan"
          env={kpiEnv}
        />
        <KpiTile
          label="Median Session"
          value={formatDuration(data.median_session_duration_sec)}
          icon={Timer}
          tone="purple"
          env={kpiEnv}
        />
        <KpiTile
          label="Avg Active"
          value={formatDuration(data.avg_active_duration_sec)}
          icon={Hourglass}
          tone="magenta"
          env={kpiEnv}
        />
        <KpiTile
          label="Engagement"
          value={formatRatioPct(data.engagement_ratio)}
          icon={Gauge}
          tone="orange"
          env={kpiEnv}
        />
        <KpiTile
          label="Total Sessions"
          value={formatCount(data.total_sessions)}
          icon={ListChecks}
          tone="cyan"
          env={kpiEnv}
        />
      </div>
    </>
  );
}
